import React from 'react';
import axios from 'axios';
import useCotizacion from 'src/hooks/useCotizacion';
import { urlCorreoInicialNotificacion, urlGetUrlPdfCotizacion } from 'src/services/urls';
import ModalDeleteBeneficiario from '../ModalDeleteBeneficiario';
import { StyledAbutton } from '../styleds';

export const ButtonBar = ({ beneficiario, index }) => {
  const { cotizacion, ...res } = useCotizacion();

  const enviarCorreo = async () => {
    try {
      const idCotizacion = res.idCotizacion;


      const getCotizacion = await axios.get(
        urlGetUrlPdfCotizacion + idCotizacion
      );

      if (getCotizacion.data?.transaccion) {

        window.open(getCotizacion.data.url, "_blank");

        const response = await axios.post(
          urlCorreoInicialNotificacion(idCotizacion, "bienvenida")
        );

        console.log("urlCorreoInicialNotificacion", response);
      }
    } catch (error) {
      console.error("Error en enviarCorreo:", error);
    }
  };

  return (
    <div className="d-flex flex-row w-100 justify-content-end">
      {cotizacion?.urlPdfCotizacion && (
        <StyledAbutton
          href="#"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault(); // evita navegación del href
            enviarCorreo();
          }}
        >
          <i className="pi pi-download" />
          Descargar
        </StyledAbutton>
      )}

      {!cotizacion?.beneficiarioIgualTitularChecked && (
        <ModalDeleteBeneficiario
          beneficiario={beneficiario}
          index={index}
        />
      )}
    </div>
  );
};
